(() => {
  // hamburger menu
  const hamburger = document.querySelector('.hamburger_menu');
  const slideMenu = document.querySelector('.slide_menu');

  if (hamburger && slideMenu) {
    hamburger.addEventListener('click', function () {
      this.classList.toggle('active');
      slideMenu.classList.toggle('active');
      document.body.classList.toggle('no-scroll');
    });
  }

  // smoothScroll
  const smoothScroll = () => {
    const elms = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
    for (const elm of elms) {
      const href = elm.getAttribute('href');
      if (!href) continue;

      if (href === '#') {
        elm.addEventListener('click', (event) => {
          event.preventDefault();
          scroll({ top: 0, behavior: 'smooth' });
        });
      } else {
        const target = document.querySelector(href);
        if (target) {
          elm.addEventListener('click', (event) => {
            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth' });
          });
        }
      }
    }
  };
  smoothScroll();
})();

